import React from 'react'


export const AppLogo = ({ ...props }) => (
  <img src={`${process.env.PUBLIC_URL}/medvertise-logo.png`} alt="Medvertise Logo" {...props} />
)
